import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
export function replaceTextUrlWithHtmlLink(text) {
  var re = /((http|https):\/\/[a-z][a-z0-9.\-_#?&/=%~]+[a-z0-9#])/gi;
  re.lastIndex = 0;
  return text.replace(re, '<a href="$1" target="__blank" rel="noopener noreferrer">$1</a>');
}